module.exports = __webpack_public_path__ + "static/media/german-categories.476a9344.jpg";